import React from 'react';
import '../../styles/Loader.css';

const Loader = () => (
  <div className="loader-overlay" role="status" aria-live="polite" aria-label="Cargando REM Enterprises">
    <div className="loader-container">
      <div className="loader-mark">
        <span className="loader-orbit loader-orbit-outer" aria-hidden="true"></span>
        <span className="loader-orbit loader-orbit-inner" aria-hidden="true"></span>
        <div className="loader-logo-wrap">
          <img
            className="loader-logo"
            src="/images/RemEnterprisesVerde.png"
            alt="REM Enterprises"
          />
        </div>
      </div>
    </div>
  </div>
);

export default Loader;
